var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__title" }, [
          _c("h5", [_vm._v("Información de la consulta")]),
          _vm._v(" "),
          _c("div", { staticClass: "card__controls" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_fecha,
                          expression: "form.tipo_fecha"
                        }
                      ],
                      attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "tipo_fecha",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "P" } }, [
                        _vm._v("Personalizado")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "tipo_fecha" } }, [
                    _vm._v("Tipo de fecha")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "fecha",
                          locale: "es",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          "only-date": "",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde")])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    { staticClass: "datepicker-field" },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "fecha",
                          locale: "es",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          "only-date": "",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta")])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid--fit mt-2" },
        [
          _c(
            "button-card",
            {
              attrs: {
                "btn-color": "btn-info",
                "fa-name": "fa-address-card",
                counter: _vm.numeroVisitas
              }
            },
            [
              _c("span", { staticStyle: { "font-size": "20px" } }, [
                _vm._v("VISITAS")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "button-card",
            {
              attrs: {
                "btn-color": "btn-success",
                "fa-name": "fa-sellsy",
                counter: _vm.numeroVentas
              }
            },
            [
              _c("span", { staticStyle: { "font-size": "20px" } }, [
                _vm._v("VENTAS")
              ]),
              _vm._v(" "),
              _c("strong", { staticStyle: { "font-size": "20px" } }, [
                _vm._v("(" + _vm._s(_vm.moneyFormat(_vm.totalVentas)) + ")")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "button-card",
            {
              attrs: {
                "btn-color": "btn-primary",
                "fa-name": "fa-calendar",
                counter: _vm.numeroRecaudaciones
              }
            },
            [
              _c("span", { staticStyle: { "font-size": "20px" } }, [
                _vm._v("RECAUDACIONES")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "button-card",
            {
              attrs: {
                "btn-color": "btn-secondary",
                "fa-name": "fa-money",
                counter: _vm.numeroAbonos
              }
            },
            [
              _c("span", { staticStyle: { "font-size": "20px" } }, [
                _vm._v("ABONOS")
              ]),
              _vm._v(" "),
              _c("strong", { staticStyle: { "font-size": "20px" } }, [
                _vm._v("(" + _vm._s(_vm.moneyFormat(_vm.totalAbonos)) + ")")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-2" }, [
        _c("div", { staticClass: "card__title" }, [
          _c("h5", [_vm._v("Mapa de ventas")]),
          _vm._v(" "),
          _c("div", { staticClass: "card__controls" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("label", { attrs: { for: "mostrar_clientes" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.mostrar_clientes,
                      expression: "form.mostrar_clientes"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "mostrar_clientes",
                    id: "mostrar_clientes"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.mostrar_clientes)
                      ? _vm._i(_vm.form.mostrar_clientes, null) > -1
                      : _vm.form.mostrar_clientes
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.form.mostrar_clientes,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "mostrar_clientes",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "mostrar_clientes",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "mostrar_clientes", $$c)
                        }
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _c("span", [_vm._v("Mostrar clientes")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "mostrar_rutas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.mostrar_rutas,
                      expression: "form.mostrar_rutas"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "mostrar_rutas",
                    id: "mostrar_rutas"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.mostrar_rutas)
                      ? _vm._i(_vm.form.mostrar_rutas, null) > -1
                      : _vm.form.mostrar_rutas
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.form.mostrar_rutas,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "mostrar_rutas",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "mostrar_rutas",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "mostrar_rutas", $$c)
                        }
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _c("span", [_vm._v("Mostrar rutas")])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        multiple: "",
                        options: _vm.vendedores,
                        placeholder: "Seleccione...",
                        label: "descripcion",
                        id: "vendedor"
                      },
                      on: {
                        search: _vm.searchVendedores,
                        input: _vm.inputVendedores
                      },
                      model: {
                        value: _vm.selectedVendedores,
                        callback: function($$v) {
                          _vm.selectedVendedores = $$v
                        },
                        expression: "selectedVendedores"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "vendedor" } }, [
                      _vm._v("Vendedor(es)")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        multiple: "",
                        options: _vm.supervisores,
                        label: "nombre",
                        placeholder: "Seleccione...",
                        id: "supervisor"
                      },
                      on: {
                        input: _vm.inputSupervisores,
                        search: _vm.searchSupervisores
                      },
                      model: {
                        value: _vm.selectedSupervisores,
                        callback: function($$v) {
                          _vm.selectedSupervisores = $$v
                        },
                        expression: "selectedSupervisores"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "supervisor" } }, [
                      _vm._v("Supervisor(es)")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        label: "descripcion",
                        multiple: "",
                        options: _vm.rutas,
                        placeholder: "Seleccione...",
                        id: "ruta"
                      },
                      on: { input: _vm.inputRutas, search: _vm.onSearchRutas },
                      model: {
                        value: _vm.selectedRutas,
                        callback: function($$v) {
                          _vm.selectedRutas = $$v
                        },
                        expression: "selectedRutas"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "ruta" } }, [_vm._v("Ruta(s)")])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.dia_cobro,
                          expression: "form.dia_cobro"
                        }
                      ],
                      attrs: { name: "dia_cobro", id: "dia_cobro" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "dia_cobro",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v("Seleccione...")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("Lunes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2" } }, [
                        _vm._v("Martes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "3" } }, [
                        _vm._v("Miércoles")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "4" } }, [
                        _vm._v("Jueves")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "5" } }, [
                        _vm._v("Viernes")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "6" } }, [
                        _vm._v("Sábado")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "7" } }, [
                        _vm._v("Domingo")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "dia_cobro" } }, [
                    _vm._v("Día de cobro")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        id: "bodega",
                        placeholder: "Seleccione...",
                        options: _vm.bodegas,
                        label: "descripcion"
                      },
                      on: { input: _vm.inputBodega },
                      model: {
                        value: _vm.selectedBodega,
                        callback: function($$v) {
                          _vm.selectedBodega = $$v
                        },
                        expression: "selectedBodega"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bodega" } }, [
                      _vm._v("Sucursal")
                    ])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-info",
                    attrs: { type: "button" },
                    on: { click: _vm.consultar }
                  },
                  [_c("i", { staticClass: "fa fa-refresh" })]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12" }, [
              _c(
                "div",
                { staticStyle: { height: "700px" } },
                [
                  _c(
                    "l-map",
                    {
                      ref: "mymap",
                      staticStyle: { height: "100%", width: "100%" },
                      attrs: { zoom: _vm.zoom, center: _vm.center },
                      on: {
                        "update:zoom": _vm.zoomUpdated,
                        "update:center": _vm.centerUpdated
                      }
                    },
                    [
                      _c("l-tile-layer", { attrs: { url: _vm.url } }),
                      _vm._v(" "),
                      _vm._l(_vm.puntosRutas, function(punto, index) {
                        return _c("l-circle-marker", {
                          key: "radio" + index,
                          attrs: {
                            radius: parseFloat(punto.radio),
                            "lat-lng": [punto.latitud, punto.longitud],
                            color: "red"
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.puntosRutas, function(punto, index) {
                        return _c(
                          "l-marker",
                          {
                            key: "punto" + index,
                            attrs: {
                              name: punto.descripcion,
                              icon: _vm.markerIcon,
                              "lat-lng": [punto.latitud, punto.longitud]
                            }
                          },
                          [
                            _c("l-tooltip", [
                              _vm._v(
                                _vm._s(punto.descripcion) +
                                  " (" +
                                  _vm._s(punto.nombre_ruta) +
                                  ")"
                              )
                            ]),
                            _vm._v(" "),
                            _c("l-popup", [
                              _c("ul", [
                                _c("li", [
                                  _c("strong", [_vm._v("Punto:")]),
                                  _vm._v(" " + _vm._s(punto.descripcion))
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Ruta:")]),
                                  _vm._v(" " + _vm._s(punto.nombre_ruta))
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Radio:")]),
                                  _vm._v(" " + _vm._s(punto.radio))
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Latitud:")]),
                                  _vm._v(" " + _vm._s(punto.latitud))
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Longitud:")]),
                                  _vm._v(" " + _vm._s(punto.longitud))
                                ])
                              ])
                            ])
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.clientes, function(cliente, index) {
                        return _c(
                          "l-marker",
                          {
                            key: "cliente" + index,
                            attrs: {
                              name: cliente.descripcion,
                              icon: cliente.icon,
                              "lat-lng": [cliente.latitud, cliente.longitud]
                            }
                          },
                          [
                            _c(
                              "l-tooltip",
                              { attrs: { options: _vm.tooltipOptions } },
                              [
                                _vm._v(
                                  _vm._s(_vm.moneyFormat(cliente.saldo)) +
                                    " (" +
                                    _vm._s(cliente.indice) +
                                    ")"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "l-popup",
                              [
                                _c("ul", [
                                  _c("li", [
                                    _c("strong", [_vm._v("Nombres:")]),
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(cliente.nombres_completos) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("Apellidos:")]),
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(cliente.apellidos_completos) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("# Identificación:")]),
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(cliente.numero_identificacion) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("Dirección:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(cliente.direccion) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  cliente.ultimo_pedido != null
                                    ? _c("li", [
                                        _c("strong", [
                                          _vm._v("Número de venta:")
                                        ]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              cliente.ultimo_pedido
                                                .numero_documento
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cliente.ultimo_pedido != null
                                    ? _c("li", [
                                        _c("strong", [_vm._v("Supervisor:")]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              cliente.ultimo_pedido
                                                .nombre_supervisor
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cliente.ultimo_pedido != null
                                    ? _c("li", [
                                        _c("strong", [
                                          _vm._v("Fecha de venta:")
                                        ]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              cliente.ultimo_pedido.fecha
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cliente.ultimo_pedido != null
                                    ? _c("li", [
                                        _c("strong", [_vm._v("Día de cobro:")]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              cliente.ultimo_pedido
                                                .descripcion_dia_cobro
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cliente.ultimo_pedido != null
                                    ? _c("li", [
                                        _c("strong", [_vm._v("Total:")]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.moneyFormat(
                                                cliente.ultimo_pedido
                                                  .venta_total
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cliente.ultimo_pedido != null
                                    ? _c("li", [
                                        _c("strong", [_vm._v("Saldo:")]),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.moneyFormat(
                                                cliente.ultimo_pedido.saldo
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("center", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn-info btn--text",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.verVentas(cliente)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-table" }),
                                      _c("span", [_vm._v("Ventas")])
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.polylines, function(polyline, index) {
                        return _c("l-polyline", {
                          key: index + polyline.color,
                          attrs: {
                            weight: 7,
                            "lat-lngs": polyline.latlngs,
                            color: polyline.color
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.polylines, function(polyline, index) {
                        return _c("l-polyline", {
                          key: index,
                          attrs: {
                            weight: 2,
                            "lat-lngs": polyline.latlngs,
                            color: "white"
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm._m(1)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c(
                "div",
                {
                  staticClass: "table-responsive",
                  staticStyle: { "max-height": "300px" }
                },
                [
                  _c("table", [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.ventasVendedor, function(
                        ventaVendedor,
                        index
                      ) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(ventaVendedor.nombre_vendedor) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(ventaVendedor.cantidad_ventas) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.moneyFormat(ventaVendedor.total_ventas)
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("th", { attrs: { scope: "row" } }, [
                          _vm._v(
                            "\n                    Totales\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.calcularCantidadVentas(_vm.ventasVendedor)
                              ) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.calcularTotalVentas(_vm.ventasVendedor)
                                )
                              ) +
                              "\n                  "
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c(
                "div",
                {
                  staticClass: "table-responsive",
                  staticStyle: { "max-height": "300px" }
                },
                [
                  _c("table", [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.ventasSupervisor, function(
                        ventaSupervisor,
                        index
                      ) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(ventaSupervisor.nombre_supervisor) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(ventaSupervisor.cantidad_ventas) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.moneyFormat(ventaSupervisor.total_ventas)
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("th", { attrs: { scope: "row" } }, [
                          _vm._v(
                            "\n                    Totales\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.calcularCantidadVentas(_vm.ventasSupervisor)
                              ) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.calcularTotalVentas(_vm.ventasSupervisor)
                                )
                              ) +
                              "\n                  "
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c(
                "div",
                {
                  staticClass: "table-responsive",
                  staticStyle: { "max-height": "300px" }
                },
                [
                  _c("table", [
                    _vm._m(7),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.ventasRecaudador, function(
                        ventaRecaudador,
                        index
                      ) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(ventaRecaudador.nombre_recaudador) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(ventaRecaudador.cantidad_ventas) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.moneyFormat(ventaRecaudador.total_ventas)
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("th", { attrs: { scope: "row" } }, [
                          _vm._v(
                            "\n                    Totales\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.calcularCantidadVentas(_vm.ventasRecaudador)
                              ) +
                              "\n                  "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.moneyFormat(
                                  _vm.calcularTotalVentas(_vm.ventasRecaudador)
                                )
                              ) +
                              "\n                  "
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(8),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [_c("line-chart", { attrs: { data: _vm.comparacionMensual } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(9),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("k-table", {
                  ref: "productosVendidos",
                  attrs: {
                    mostrarTotales: false,
                    createButton: false,
                    deleteButton: false,
                    editButton: false,
                    path: _vm.pathProductosVendidos,
                    filterStatus: false,
                    params: _vm.form,
                    buscarButton: false,
                    columns: [
                      {
                        display: "Producto",
                        value: "descripcion_item"
                      },
                      {
                        display: "Cantidad",
                        value: "cantidad",
                        numeric: true
                      },
                      {
                        display: "Total",
                        value: "total",
                        numeric: true,
                        prefijo: "$"
                      }
                    ]
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(10),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("k-table", {
                  ref: "premiosEntregados",
                  attrs: {
                    mostrarTotales: false,
                    createButton: false,
                    deleteButton: false,
                    editButton: false,
                    path: _vm.pathPremiosEntregados,
                    filterStatus: false,
                    params: _vm.form,
                    buscarButton: false,
                    columns: [
                      {
                        display: "Producto",
                        value: "descripcion_item"
                      },
                      {
                        display: "Cantidad",
                        value: "cantidad",
                        numeric: true
                      },
                      {
                        display: "Total",
                        value: "total",
                        numeric: true,
                        prefijo: "$"
                      }
                    ]
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(11),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("k-table", {
                  ref: "productosDevueltos",
                  attrs: {
                    mostrarTotales: false,
                    createButton: false,
                    deleteButton: false,
                    editButton: false,
                    path: _vm.pathProductosDevueltos,
                    filterStatus: false,
                    params: _vm.form,
                    buscarButton: false,
                    columns: [
                      {
                        display: "Producto",
                        value: "descripcion_item"
                      },
                      {
                        display: "Cantidad",
                        value: "cantidad",
                        numeric: true
                      },
                      {
                        display: "Total",
                        value: "total",
                        numeric: true,
                        prefijo: "$"
                      }
                    ]
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "ventasDashboard",
            scrollable: "",
            height: "auto",
            width: "75%",
            resizable: "",
            adaptive: "",
            reset: ""
          }
        },
        [
          _c("ventas-dashboard", {
            attrs: { ventas: _vm.ventasCliente },
            on: { cerrar: _vm.cerrarVentas }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Ventas")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("div", { staticClass: "form-inline" }, [
        _c("img", { attrs: { src: "/images/dias-cobro/1.png", alt: "Lunes" } }),
        _c("label", { attrs: { for: "lunes" } }, [_vm._v("Lunes")]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/dias-cobro/2.png", alt: "Martes" }
        }),
        _c("label", { attrs: { for: "martes" } }, [_vm._v("Martes")]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/dias-cobro/3.png", alt: "Miércoles" }
        }),
        _c("label", { attrs: { for: "miercoles" } }, [_vm._v("Miércoles")]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/dias-cobro/4.png", alt: "Jueves" }
        }),
        _c("label", { attrs: { for: "jueves" } }, [_vm._v("Jueves")]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/dias-cobro/5.png", alt: "Viernes" }
        }),
        _c("label", { attrs: { for: "viernes" } }, [_vm._v("Viernes")]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/dias-cobro/6.png", alt: "Sábado" }
        }),
        _c("label", { attrs: { for: "sabado" } }, [_vm._v("Sábado")]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/dias-cobro/7.png", alt: "Domingo" }
        }),
        _c("label", { attrs: { for: "domingo" } }, [_vm._v("Domingo")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Ventas por vendedor")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Vendedor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cant. Ventas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. Ventas")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Ventas por supervisor")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Supervisor")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cant. Ventas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. Ventas")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Ventas por recaudador")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Recaudador")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cant. Ventas")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tot. Ventas")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Comparación mensual")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Productos vendidos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Premios entregados")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Productos devueltos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ee60be6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee60be6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/Dashboard.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2ee60be6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/Dashboard.vue
// module chunks = 0